import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Visibility = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M29.7688 15.3606C29.519 15.0601 23.5617 8 16 8C8.43822 8 2.48097 15.0601 2.23109 15.3606C1.92297 15.7311 1.92297 16.2687 2.23109 16.6392C2.48097 16.9397 8.43822 23.9999 16 23.9999C23.5617 23.9999 29.519 16.9397 29.7688 16.6392C30.077 16.2687 30.077 15.7311 29.7688 15.3606ZM16 22C10.6277 22 5.95047 17.6643 4.35334 16C5.38072 14.9295 7.68209 12.7565 10.6216 11.3404C10.2243 12.1421 9.99997 13.0446 9.99997 14C9.99997 17.3138 12.6862 20 16 20C19.3137 20 22 17.3138 22 14C22 13.0446 21.7756 12.142 21.3783 11.3403C24.3178 12.7564 26.6192 14.9295 27.6466 16C26.0488 17.6649 21.3717 22 16 22Z" />
	</svg>
);

export default Visibility;
